import React from 'react';
import axios from 'axios';
import { useAlerts } from 'components/Alerts';
import Switch from 'components/subscriptions/Switch';

const SlackSwitch = ({ slackAuthUrl, deletePath, projectSubscriptionTransportId = null}) => {
  const alerts = useAlerts();

  const [loading, setLoading] = React.useState(false);
  const [checked, setChecked] = React.useState(!!projectSubscriptionTransportId);

  const onCreate = React.useCallback(() => {
    setLoading(true);
    setChecked(true);
    window.location = slackAuthUrl;
  }, [slackAuthUrl]);

  const onDestroy = React.useCallback(() => {
    setLoading(true);
    setChecked(false);
    axios.delete(deletePath)
      .then(() => {
        // alerts.success('You have been unsubscribed from slack notifications.');
        window.location.reload();
      })
      .catch(() => {
        setChecked(true);
        alerts.error('Could not unsubscribe from slack notifications. Please try again or contact support@launchnotes.com for assistance');
      })
      .finally(() => setLoading(false));
  }, [deletePath]);

  return (
    <Switch
      id="slack-switch"
      loading={loading}
      checked={checked}
      onChange={(value) => (value ? onCreate() : onDestroy())}
    />
  );
};

export default SlackSwitch;
